function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import isFunction from 'lodash/isFunction';
import pick from 'lodash/pick';
import { withHotKeys } from 'react-hotkeys';
import { componentPropType } from '../utils/propTypes';
import TextInput from '../textInput/TextInput';
import InputField from '../inputField/InputField';
import TextList from '../textList/TextList';
import Dropdown from '../containers/dropdown/Dropdown';
import { TEXT_ITEMS_PROP_TYPE } from '../textList/constants';
import { TABBABLE_INDEX, UNTABBABLE_INDEX, HIDE_CHILD, SHOW_CHILD, RESET_STATE, ACTIVATE_ITEM } from '../hotKeys/constants';
import { ACTION_KEY_MAP } from './hotKeys';

var DefaultDropdownContentContainer = function DefaultDropdownContentContainer(_ref) {
  var children = _ref.children;
  return React.createElement("div", {
    className: "eds-autocomplete-field__content",
    "data-spec": "autocompletefield-dropdown-content"
  }, children);
};

var getStateWithEnteredValue = function getStateWithEnteredValue(stateObject, enteredValue) {
  return _objectSpread({}, stateObject, {
    value: enteredValue,
    enteredValue: enteredValue
  });
};

var DEFAULT_INPUT_FIELD_PROPS = {
  style: 'basic',
  label: 'autocomplete'
};
var INITIAL_FOCUS_POSITION = -1;
var NAVIGATION_FOCUS_POSITION = 0;
var INITIAL_STATE = {
  /*
   * Boolean, true if searchSuggestions should be shown
   */
  hasFocus: false,

  /*
   * Should be 0 for tab sequence, unless searchSuggestions are shown
   */
  tabIndex: TABBABLE_INDEX,

  /*
   * Set at -1 when no searchSuggestions are shown, 0 when searchSuggestions are shown
   */
  focusPosition: INITIAL_FOCUS_POSITION,

  /*
   * Boolean, true if the input field should receive focus
   */
  shouldFocusInput: false,

  /*
   * String, value that the user enters, saved for toggling into input field
   */
  enteredValue: ''
}; // State when we want to navigate within searchSuggestions

var NAVIGATION_STATE = {
  hasFocus: true,
  tabIndex: UNTABBABLE_INDEX,
  focusPosition: NAVIGATION_FOCUS_POSITION,
  shouldFocusInput: false
}; // State when we want to show searchSuggestions while typing into input field

var INPUT_STATE = {
  hasFocus: true,
  tabIndex: TABBABLE_INDEX,
  focusPosition: INITIAL_FOCUS_POSITION,
  shouldFocusInput: true
}; // State when we want to hide searchSuggestions while focusing input field

var FOCUS_STATE = {
  hasFocus: false,
  tabIndex: TABBABLE_INDEX,
  focusPosition: INITIAL_FOCUS_POSITION,
  shouldFocusInput: true
}; // State when we want to hide searchSuggestions and not focus the input field

var HIDE_SUGGEST_NO_FOCUS_STATE = {
  hasFocus: false,
  tabIndex: TABBABLE_INDEX,
  focusPosition: INITIAL_FOCUS_POSITION,
  shouldFocusInput: false
};

var AutocompleteField =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(AutocompleteField, _React$PureComponent);

  function AutocompleteField(props) {
    var _defineProperty2;

    var _this;

    _classCallCheck(this, AutocompleteField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AutocompleteField).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "hotKeyHandlers", (_defineProperty2 = {}, _defineProperty(_defineProperty2, RESET_STATE, function () {
      return _this.setState(function (_ref2) {
        var enteredValue = _ref2.enteredValue;
        return getStateWithEnteredValue(INITIAL_STATE, enteredValue);
      });
    }), _defineProperty(_defineProperty2, HIDE_CHILD, function () {
      return _this.setState(function (_ref3) {
        var enteredValue = _ref3.enteredValue;
        return getStateWithEnteredValue(INPUT_STATE, enteredValue);
      });
    }), _defineProperty(_defineProperty2, SHOW_CHILD, function (e) {
      e.preventDefault();
      e.stopPropagation();
      var stateToSet = !isEmpty(_this.props.suggestions) ? NAVIGATION_STATE : INITIAL_STATE;

      _this.setState(_objectSpread({}, stateToSet, {
        keyboardAction: SHOW_CHILD
      }));
    }), _defineProperty(_defineProperty2, ACTIVATE_ITEM, function (e) {
      var _this$props = _this.props,
          isLimitedSearch = _this$props.isLimitedSearch,
          suggestions = _this$props.suggestions;

      _this._handleEnterKey(_this.state.value); // e.preventDefault should not be called for non-Limited searches to allow for
      // correct submission when AutocompleteField is wrapped by form (i.e. Event Search)


      if (isLimitedSearch) {
        e.preventDefault();

        if (suggestions.length && suggestions[0].value) {
          _this._handleItemSelect(suggestions[0].value);
        }

        return FOCUS_STATE;
      }

      _this._handleItemSelect(_this.state.value);

      return {};
    }), _defineProperty2));

    var value = props.value || props.defaultValue;
    _this.state = _objectSpread({}, INITIAL_STATE, {
      value: value,
      enteredValue: value || ''
    });
    return _this;
  }

  _createClass(AutocompleteField, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref4) {
      var value = _ref4.value,
          shouldFocusInput = _ref4.shouldFocusInput;

      // When values are passed in via mapDispatchToProps (Redux), setting state here ensures that
      // fields populate as expected in core
      if (value !== undefined) {
        this.setState({
          value: value,
          shouldFocusInput: shouldFocusInput,
          enteredValue: value
        });
      }
    }
  }, {
    key: "_resetState",
    value: function _resetState() {
      this.setState(function (_ref5) {
        var enteredValue = _ref5.enteredValue;
        return getStateWithEnteredValue(INITIAL_STATE, enteredValue);
      });
    }
  }, {
    key: "_handleInputChange",
    value: function _handleInputChange(value) {
      var onChange = this.props.onChange;
      this.setState(_objectSpread({}, INPUT_STATE, {
        value: value,
        enteredValue: value
      }));

      if (onChange) {
        onChange(value);
      }
    }
  }, {
    key: "_handleItemTentativeSelect",
    value: function _handleItemTentativeSelect(value, content) {
      var preventInputValuePrefill = this.props.preventInputValuePrefill;
      var inputDisplayText = value;

      if (preventInputValuePrefill) {
        return;
      } // For display purposes, content is prioritized rather
      // than referencing the event hashes or url (i.e. values for event/location search)


      if (typeof content === 'string') {
        inputDisplayText = content;
      }

      this.setState({
        value: inputDisplayText,
        shouldFocusInput: false,
        focusPosition: 0
      });
    }
  }, {
    key: "_handleInputFocus",
    value: function _handleInputFocus(value) {
      var onFocus = this.props.onFocus;

      if (this.state.shouldFocusInput) {
        this.setState(FOCUS_STATE);
      } else {
        this.setState(INPUT_STATE);
      }

      if (onFocus) {
        onFocus(value);
      }
    }
  }, {
    key: "_handleInputFocusToggle",
    value: function _handleInputFocusToggle() {
      this.setState(function (_ref6) {
        var enteredValue = _ref6.enteredValue;
        return getStateWithEnteredValue(INPUT_STATE, enteredValue);
      });
    }
  }, {
    key: "_handleInputBlur",
    value: function _handleInputBlur(value) {
      var onBlur = this.props.onBlur;
      this.setState({
        shouldFocusInput: false
      });

      if (onBlur) {
        onBlur(value);
      }
    }
  }, {
    key: "_handleItemSelect",
    value: function _handleItemSelect(itemValue) {
      var _this$props2 = this.props,
          onSelect = _this$props2.onSelect,
          shouldFocusInputOnSelect = _this$props2.shouldFocusInputOnSelect;
      var baseState = shouldFocusInputOnSelect ? FOCUS_STATE : HIDE_SUGGEST_NO_FOCUS_STATE;
      this.setState(_objectSpread({}, baseState, {
        enteredValue: itemValue,
        value: itemValue
      }));

      if (onSelect) {
        onSelect(itemValue);
      }
    }
  }, {
    key: "_handleEnterKey",
    value: function _handleEnterKey(value) {
      var onEnterKey = this.props.onEnterKey;

      if (onEnterKey) {
        onEnterKey(value);
      }
    }
  }, {
    key: "_handleClickOutside",
    value: function _handleClickOutside(e) {
      // If they click the input, we don't want to dismiss the dropdown
      // even though it's technically outside of the dropdown
      if (!e.target.id || e.target.id !== this.props.id) {
        this._resetState();
      }
    }
  }, {
    key: "_shouldShowSuggestions",
    value: function _shouldShowSuggestions() {
      var hasFocus = this.state.hasFocus;
      var _this$props3 = this.props,
          suggestions = _this$props3.suggestions,
          shouldShowDropdown = _this$props3.shouldShowDropdown;

      if (!hasFocus) {
        return false;
      }

      if (isFunction(shouldShowDropdown)) {
        return shouldShowDropdown(this.props);
      }

      return suggestions.length;
    }
  }, {
    key: "_handleInputReset",
    value: function _handleInputReset() {
      var _this$state = this.state,
          enteredValue = _this$state.enteredValue,
          hasFocus = _this$state.hasFocus;

      if (hasFocus) {
        this.setState({
          value: enteredValue
        });
      }
    }
  }, {
    key: "_handleInputClick",
    value: function _handleInputClick() {
      this.setState(INPUT_STATE);
    }
  }, {
    key: "_renderTextList",
    value: function _renderTextList(suggestions, listboxId, currentValue, focusPosition, keyboardAction, isLimitedSearch, autoscrollToSelected, scrollContainerSelector) {
      return React.createElement(TextList, {
        id: listboxId,
        items: suggestions,
        selectedItem: currentValue,
        defaultFocusPosition: focusPosition,
        onItemSelect: this._handleItemSelect.bind(this),
        "aria-expanded": true,
        autoscrollToSelected: autoscrollToSelected,
        scrollContainerSelector: scrollContainerSelector,
        preventFocusWrap: true,
        onParentFocus: this._handleInputFocusToggle.bind(this),
        parentKeyboardAction: keyboardAction,
        shouldFocusFirstItem: isLimitedSearch,
        onItemTentativeSelect: this._handleItemTentativeSelect.bind(this),
        staticFocusOnTentativeSelect: this.props.preventInputValuePrefill
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          id = _this$props4.id,
          suggestions = _this$props4.suggestions,
          DropdownContentContainer = _this$props4.DropdownContentContainer,
          autoscrollToSelected = _this$props4.autoscrollToSelected,
          scrollContainerSelector = _this$props4.scrollContainerSelector,
          children = _this$props4.children,
          isLimitedSearch = _this$props4.isLimitedSearch,
          isV2 = _this$props4.isV2,
          shouldRemoveConflictiveAria = _this$props4.shouldRemoveConflictiveAria;
      var _this$state2 = this.state,
          hasFocus = _this$state2.hasFocus,
          tabIndex = _this$state2.tabIndex,
          focusPosition = _this$state2.focusPosition,
          keyboardAction = _this$state2.keyboardAction,
          shouldFocusInput = _this$state2.shouldFocusInput,
          value = _this$state2.value;
      var listboxId = "".concat(id, "-listbox");

      var onClickOutside = this._handleClickOutside.bind(this);

      var dropdown;

      if (this._shouldShowSuggestions()) {
        dropdown = React.createElement(Dropdown, {
          onClickOutside: onClickOutside
        }, React.createElement(DropdownContentContainer, {
          suggestions: suggestions,
          value: value,
          hasFocus: hasFocus
        }, this._renderTextList(suggestions, listboxId, value, focusPosition, keyboardAction, isLimitedSearch, autoscrollToSelected, scrollContainerSelector)));
      }
      /* Logic for handling v2 inputs vs v1 */


      var InputComponent = TextInput;

      var inputProps = _objectSpread({
        children: children
      }, pick.apply(void 0, [this.props].concat(_toConsumableArray(Object.keys(TextInput.propTypes)))));

      if (isV2) {
        InputComponent = InputField;
        inputProps = _objectSpread({}, DEFAULT_INPUT_FIELD_PROPS, pick.apply(void 0, [this.props].concat(_toConsumableArray(Object.keys(InputField.propTypes)))));
      }
      /*
       * Chrome's `autofill` function is conflicting with autocompelte.
       * Documentation points that setting something semantic as
       * `autocomplete="user-selection-from-list"` or
       * `autocomplete="none"` or
       * `autocomplete="nope"` should work
       * but in the end `autocomplete="off"` is the one that seems to be working
       *
       * https://caniuse.com/#search=autocomplete
       * https://bugs.chromium.org/p/chromium/issues/detail?id=468153#c164
       */

      /*
       * The InputComponent always received an `aria-owns={listboxId}`.
       * Aria-owns work is to bind two elements that can not be related directly by hierarchy.
       * https://www.w3.org/WAI/PF/aria-1.1/states_and_properties#aria-owns
       * Currently this is generating issues with our audit tools and seems to be missing
       * from current implementations of the standard.
       * In order to test this we should be able to toggle this conflictive aria attribute.
       */


      var ariaAttrs = {
        'aria-expanded': hasFocus,
        'aria-autocomplete': 'list'
      };

      if (!shouldRemoveConflictiveAria) {
        ariaAttrs = _objectSpread({}, ariaAttrs, {
          'aria-owns': listboxId
        });
      }

      return React.createElement("div", {
        className: "eds-autocomplete-field",
        "data-spec": "autocompletefield-field"
      }, React.createElement("div", {
        className: "eds-autocomplete-field__dropdown-holder"
      }, React.createElement(InputComponent, _extends({}, inputProps, ariaAttrs, {
        value: value,
        id: id,
        role: "combobox",
        autoComplete: "off",
        onClick: this._handleInputClick.bind(this),
        onChange: this._handleInputChange.bind(this),
        onFocus: this._handleInputFocus.bind(this),
        onBlur: this._handleInputBlur.bind(this),
        tabIndex: tabIndex,
        shouldFocus: shouldFocusInput,
        onMouseOver: this._handleInputReset.bind(this)
      })), dropdown));
    }
  }]);

  return AutocompleteField;
}(React.PureComponent);

_defineProperty(AutocompleteField, "propTypes", _objectSpread({}, TextInput.propTypes, {
  /**
   * The component root element ID (also used to generate child element IDs)
   */
  id: PropTypes.string.isRequired,

  /**
   * The suggestions to offer (may be an empty array)
   */
  suggestions: TEXT_ITEMS_PROP_TYPE.isRequired,

  /**
   * The component class to wrap around the dropdown content.
   * This is enables a customized dropdown design
   * (i.e. - show powered by google places for location)
   */
  DropdownContentContainer: componentPropType,

  /**
   * Called when an option is selected
   * Passed the value of the selection option
   */
  onSelect: PropTypes.func,

  /**
   * Called for every change in the text input entry field
   * Passed the contents of the input
   */
  onChange: PropTypes.func,

  /**
   * Called when the text input entry is blurred
   * Passed the contents of the input
   */
  onBlur: PropTypes.func,

  /**
   * Called when the text input entry is focused
   * Passed the contents of the input
   */
  onFocus: PropTypes.func,

  /**
   * Called when the text input entry receives an enter key
   * Passed the contents of the input
   */
  onEnterKey: PropTypes.func,

  /**
   * Called when a key is pressed
   * Passed the contents of the input
   */
  onKeyDown: PropTypes.func,

  /**
   * Should this list try to scroll to the selected item?
   * This is a passthrough prop for TextList
   */
  autoscrollToSelected: PropTypes.bool,

  /**
   * A valid CSS selector of the parent scroll container
   * This is required if autoscrollToSelected prop is true
   * This is a passthrough prop for TextList
   */
  scrollContainerSelector: PropTypes.string,

  /**
   * Should we display the dropdown? Called during render when `hasFocus`.
   * This function will receive the current props and should return a bool.
   */
  shouldShowDropdown: PropTypes.func,

  /**
   * Should we focus the input field? Changes the state on `componentWillReceiveProps`.
   */
  shouldFocusInput: PropTypes.bool,

  /**
   * Should we focus back on the event field after the user has selected an autocomplete
   * result
   */
  shouldFocusInputOnSelect: PropTypes.bool,

  /**
   * TextInput supports 1 or 2 icon children,
   * which turns the component into a Text Input w/ icons
   */
  children: TextInput.propTypes.children,

  /**
   * Whether or not the search is limited to items in suggestions
   */
  isLimitedSearch: PropTypes.bool,

  /**
   * Flag for the autocomplete to use InputField rather than TextInput as the base
   */
  isV2: PropTypes.bool,

  /**
   * Boolean to determine if on tentativeItemSelect the value should be prefilled
   * into the input and focus dropped
   */
  preventInputValuePrefill: PropTypes.bool,

  /**
   * Boolean to determine if conflictive aria attributes should not be rendered.
   * Often helpful to increase audit results on pages but allowing to easily switch
   * them on again if a component doesn't behaves as expected.
   */
  shouldRemoveConflictiveAria: PropTypes.bool
}));

_defineProperty(AutocompleteField, "defaultProps", {
  DropdownContentContainer: DefaultDropdownContentContainer,
  isLimitedSearch: false,
  preventInputValuePrefill: false,
  shouldRemoveConflictiveAria: false,
  shouldFocusInputOnSelect: true
});

export default withHotKeys(ACTION_KEY_MAP)(AutocompleteField);